import { useState, useRef, useEffect } from 'react';
import { useWalletModal } from './WalletModalContext';
import '../styles/Navbar.css';

const NAV_LINKS = [
  { label: 'BlazeSwap', href: 'https://blazeswap.xyz/' },
  { label: 'SparkDEX', href: 'https://sparkdex.ai/' },
  { label: 'Ēnosys', href: 'https://www.enosys.global/' },
  { label: 'Kinetic', href: 'https://kinetic.market/' },
  { label: 'Mint FAssets', href: null },
];

const DEVELOPER_HUB = { label: 'Developer Hub', href: 'https://dev.flare.network/' };

function NavLinkItem({ label, href, onNavigate }) {
  const inner = (
    <>
      <span className="navbar__link-arrow">→</span>
      <span>{label}</span>
    </>
  );

  if (href) {
    return (
      <a href={href} className="navbar__link-item" onClick={onNavigate}>
        {inner}
      </a>
    );
  }

  return (
    <button type="button" className="navbar__link-item" onClick={onNavigate}>
      {inner}
    </button>
  );
}

function filterPageSections(query) {
  const sections = document.querySelectorAll('.App > section, .App > footer');
  const trimmed = query.trim().toLowerCase();

  if (!trimmed) {
    sections.forEach((el) => el.classList.remove('search-hidden'));
    return true;
  }

  let anyMatch = false;
  sections.forEach((el) => {
    const matches = el.textContent.toLowerCase().includes(trimmed);
    el.classList.toggle('search-hidden', !matches);
    if (matches) anyMatch = true;
  });
  return anyMatch;
}

function Navbar() {
  const { open: openWalletModal } = useWalletModal();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [notFound, setNotFound] = useState(false);
  const searchInputRef = useRef(null);
  const logoUrl = `${process.env.PUBLIC_URL}/images/flare-icon.png`;

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (searchOpen) searchInputRef.current?.focus();
  }, [searchOpen]);

  useEffect(() => {
    const found = filterPageSections(searchQuery);
    setNotFound(searchQuery.trim().length > 0 && !found);
  }, [searchQuery]);

  const openSearch = () => setSearchOpen(true);

  const closeSearch = () => {
    setSearchOpen(false);
    setSearchQuery('');
  };

  const handleFxrpStaking = () => {
    closeMenu();
    openWalletModal();
  };

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <a href="/" className="navbar__logo">
          <img src={logoUrl} alt="Flare" className="navbar__logo-img" />
        </a>

        {!searchOpen && (
          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <NavLinkItem label={link.label} href={link.href} onNavigate={closeMenu} />
              </li>
            ))}
            <li>
              <button type="button" className="navbar__link-item" onClick={handleFxrpStaking}>
                <span className="navbar__link-arrow">→</span>
                <span>FXRP Staking with Firelight</span>
              </button>
            </li>
            <li>
              <a href={DEVELOPER_HUB.href} className="navbar__devhub" onClick={closeMenu}>
                {DEVELOPER_HUB.label}
              </a>
            </li>
          </ul>
        )}

        {searchOpen && (
          <div className="navbar__search-form">
            <input
              ref={searchInputRef}
              type="text"
              className="navbar__search-input"
              placeholder="Search…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {notFound && <span className="navbar__search-nomatch">No match found</span>}
          </div>
        )}

        <div className="navbar__actions">
          {!searchOpen && (
            <button
              className="navbar__hamburger"
              aria-label={menuOpen ? 'Close menu' : 'Toggle menu'}
              onClick={() => setMenuOpen((v) => !v)}
            >
              {menuOpen ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="5" y1="5" x2="19" y2="19" stroke="#E4004C" strokeWidth="2" strokeLinecap="round" />
                  <line x1="19" y1="5" x2="5" y2="19" stroke="#E4004C" strokeWidth="2" strokeLinecap="round" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="3" y1="6" x2="21" y2="6" stroke="#E4004C" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="12" x2="21" y2="12" stroke="#E4004C" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="18" x2="21" y2="18" stroke="#E4004C" strokeWidth="2" strokeLinecap="round" />
                </svg>
              )}
            </button>
          )}

          {searchOpen ? (
            <button className="navbar__search" aria-label="Close search" onClick={closeSearch}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="5" y1="5" x2="19" y2="19" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" />
                <line x1="19" y1="5" x2="5" y2="19" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          ) : (
            <button className="navbar__search" aria-label="Open search" onClick={openSearch}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11" r="7" stroke="#1a1a1a" strokeWidth="2" />
                <path d="M21 21L16.65 16.65" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;